import { render, StrictMode } from "@wordpress/element";
import { Flyout } from "../mainnavigation/Flyout";
import { Item, ModalNavigation } from "../mainnavigation/ModalNavigation";

export const SwtMainnavigationFlyout = {
  connectedCallback(elm: HTMLElement) {
    const linkElm = elm.querySelector("a");

    let html = "";
    const templateElm = elm.querySelector("template");
    if (templateElm) {
      html = templateElm.innerHTML;
    }

    let iconOpen = null;
    let iconClose = null;
    const iconElm = linkElm.querySelector("i");
    if (iconElm) {
      iconClose = iconElm.getAttribute("data-close");
      iconOpen = iconElm.getAttribute("class");
    }

    let instance = null;
    const onSetup = (flyout: any) => {
      instance = flyout;
    };

    linkElm.onclick = (e) => {
      e.preventDefault();
      const open = instance.trigger();
      if (iconElm) {
        if (open) {
          iconElm.setAttribute("class", iconClose);
        } else {
          iconElm.setAttribute("class", iconOpen);
        }
      }
    };

    const wrapper = document.createElement("div");
    elm.appendChild(wrapper);

    render(
      <StrictMode>
        <Flyout onSetup={onSetup} html={html} />
      </StrictMode>,
      wrapper
    );
  }
}


export const SwtMainnavigationModal = {
  connectedCallback(elm: HTMLElement) {
    const buildItem = (li: Element) => {
      const a = li.querySelector("a");

      let active = false;
      if (a.hasAttribute("aria-current")) {
        active = true;
      }

      let icon = null;
      const i = a.querySelector("i");
      if (i) {
        icon = {
          open: i.getAttribute("class"),
          close: i.getAttribute("data-close")
        };
      }

      const item: Item = {
        title: a.textContent,
        href: a.getAttribute("href"),
        active: active,
        icon: icon,
        children: []
      };

      const childrenElm = li.querySelectorAll("ul > li");
      childrenElm.forEach(child => {
        item.children.push(buildItem(child));
      });

      return item;
    };

    const getItems = () => {
      const items: Item[] = [];

      const list = document.querySelectorAll("nav#swt-mainnavigation > ul > li");
      list.forEach(li => {
        const item = buildItem(li);
        items.push(item);
      });

      return items;
    };

    elm.onclick = () => {
      elm.onclick = null;
      const button = elm.innerHTML;
      render(
        <StrictMode>
          <ModalNavigation button={button} items={getItems()}></ModalNavigation>
        </StrictMode>,
        elm
      );
    };
  }
}


export const SwtMainnavigationFixed = {
  connectedCallback(elm: HTMLElement) {
    let scrolledFromTop = window.pageYOffset >= 50;

    const elements = [];
    elm.querySelectorAll(".swt-mainnavigation-fixed").forEach(elm => {
      if (elm.hasAttribute("data-fixed-on") || elm.hasAttribute("data-fixed-off")) {
        elements.push(elm);
      }
    })

    const update = () => {
      elements.forEach(elm => {
        if (scrolledFromTop) {
          if (elm.hasAttribute("data-fixed-off")) {
            elm.classList.remove(...elm.getAttribute("data-fixed-off").split(" "));
          }

          if (elm.hasAttribute("data-fixed-on")) {
            elm.classList.add(...elm.getAttribute("data-fixed-on").split(" "));
          }
        } else {
          if (elm.hasAttribute("data-fixed-off")) {
            elm.classList.add(...elm.getAttribute("data-fixed-off").split(" "));
          }

          if (elm.hasAttribute("data-fixed-on")) {
            elm.classList.remove(...elm.getAttribute("data-fixed-on").split(" "));
          }
        }
      });
    };

    window.addEventListener("scroll", () => {
      if (window.pageYOffset >= 50) {
        if (!scrolledFromTop) {
          scrolledFromTop = true;
          update();
        }
      } else {
        if (scrolledFromTop) {
          scrolledFromTop = false;
          update();
        }
      }
    });

    if (scrolledFromTop) {
      update();
    }
  }
}
